import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { AttributesProps } from '../../../../../devices/commons/register-device';
import { Endpoint } from '../../../../../../constants/endpoints';
import { ModalityAndInvasiveMechanicalType } from '../nursing-interventions-records-type';
export interface GetAttributesRequest {
  encounterId: number,
  nursingInterventionsId?: number,
  patientId: number,
}
export interface GetAttributesRespirationAndInvasiveRequest {
  respirationType?: string,
}
export class GetAttributeModality {
  public static execute({ respirationType }: GetAttributesRespirationAndInvasiveRequest): Promise<ModalityAndInvasiveMechanicalType> {
    return HttpService
      .get<ModalityAndInvasiveMechanicalType>(Endpoint.ADEP_GET_NURSING_INTERVENTION_MODALITY, {
      respirationType
    })
      .then(response => {
        const responseBody = response.body as unknown as ModalityAndInvasiveMechanicalType;
        return responseBody
      });
  }
}

export default class GetAttributesService {
  public static execute({ encounterId, nursingInterventionsId, patientId }: GetAttributesRequest): Promise<AttributesProps> {
    return HttpService
      .get<AttributesProps>(Endpoint.ADEP_GET_NURSING_INTERVENTION_ATTRIBUTES, {
      encounterId,
      nursingInterventionsId,
      patientId,

    })
      .then(response => {
        const responseBody = response.body as AttributesProps;
        return responseBody
      });
  }
}
